import { useRef } from 'react';
import { toast } from 'sonner';
import { orderService } from '@/entities/Order/api/orderService';
import { showConfirmDialog } from '@/shared/ui/ConfirmDialogWithComment/confirmDialogState';

/** Подтверждает запуск заказа оператором и обновляет источник после сохранения */
export const useStartOrderByAdmin = (onChanged?: () => void | Promise<void>) => {
    const pending = useRef(new Set<string>());

    /** Открывает подтверждение запуска без создания трекера */
    return (orderId: string): void => {
        showConfirmDialog({
            header: 'Начать выполнение заказа',
            message: 'Заказ перейдёт в выполнение без запуска трекера.',
            acceptLabel: 'Начать выполнение',
            showCommentField: false,
            onConfirm: async () => {
                if (pending.current.has(orderId)) return;

                pending.current.add(orderId);

                try {
                    await orderService.startOrderByAdmin(orderId);
                    toast.success('Действие выполнено');
                    await onChanged?.();
                } finally {
                    pending.current.delete(orderId);
                }
            },
        });
    };
};
